import React from 'react'
import classnames from 'classnames'
import styles from './PopupHeader.less'
import TouchFeedback from './TouchFeedback'

function PopupHeader({ title, locale = { cancel: "取消", confirm: "确认" }, onCancel, onConfirm }) {
    return <div className={classnames(styles['popup-header'], styles['border-buttom-1px'])}>
        <TouchFeedback activeClassName={styles['popup-header-btn-active']}>
            <div className={styles['popup-header-cancel']} onClick={onCancel}>{locale.cancel}</div>
        </TouchFeedback>
        <div className={styles['popup-header-center']}>{title}</div>
        <TouchFeedback activeClassName={styles['popup-header-btn-active']}>
            <div className={styles['popup-header-confirm']} onClick={onConfirm}>{locale.confirm}</div>
        </TouchFeedback>
    </div>
}

export default PopupHeader
